import styled from 'styled-components';
import { Row, RowsContainer } from '../styles';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const InputsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.l}rem 9.8rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spaces.l}rem;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
`;

/**
 * La columna de campos, con tope y con filas que se parten (2026-08-17).
 *
 * No tenía NINGUNA regla de ancho: como elemento flex se dimensionaba a su
 * contenido, o sea al ancho de su fila más larga. Mientras las filas fueron de
 * dos campos eso daba 654 px y colaba; al repartirlas de tres se fue a 874, y
 * los 220 px de más se los quitó a «Descripción validada» —que sí tiene
 * `min-width`— dejándola clavada en su mínimo de 366 px (medido a 1920).
 *
 * Ahora las dos columnas son simétricas (`flex: 1 1 0` + el mismo tope), así que
 * se reparten el ancho a la mitad y la descripción no paga el reparto de la
 * izquierda.
 *
 * Y deja de ser una pila de `Row` cortadas a mano para ser **un solo contenedor
 * que envuelve**. Los controles tienen ancho fijo por tamaño (Predefinidos 350,
 * los cinco largos 270, el interruptor 200, Corte de carril 120, hueco 32), así
 * que cualquier corte fijo deja filas huérfanas a algún ancho: tres de 270 piden
 * 834 y aquí caben 607. Empaquetando en greedy se llenan solas y se reordenan al
 * estrechar, conservando el orden del DOM, que es la cascada.
 *
 * No se toca el `Row` compartido de `ActionForms`: lo usan los otros
 * formularios y allí el corte fijo es el correcto.
 */
export const RowsContainerLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spaces.l}rem;

  flex: 1 1 0;
  min-width: 0;
  max-width: 65.4rem;
`;

export const RowsContainerRight = styled(RowsContainer)`
  max-width: 65.4rem;
  min-width: 36.6rem;
  flex: 1;
  flex: 1 1 0;
`;

export const AddImagesButton = styled(MainButton)`
  align-self: flex-start;
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const SketchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

/** «Recalcular con el recorrido», bajo el título del horario (12-oct). */
export const BasicScheduleActions = styled.div`
  display: flex;
  justify-content: flex-start;
`;

/** Horario de la Actuació bàsica, debajo de la descripción (FR-9.3). */
export const BasicScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const SketchImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const ContainerInputLoads = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
  align-items: center;
`;

export const NormalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const HiddenInput = styled.input`
  display: none;
`;

// V4 FR-9.3 — bloque opt-in Materials/Animals visible solo en SR mode.
